import type { ReactNode } from "react";
import { Box, Grid } from "@mui/joy";
import DarkInput from "../../../common/DarkInput";
import IconButtonCTA from "../../../common/IconButtonCTA";
import { OpenInNewIcon, CloudUploadIcon } from "../../../../styles/StyledMUI";
type Props = {
  actionsWidth: number;
  rowLabel: string;
  resourceUrl?: string | null;
  openAriaLabel: string;
  uploadAriaLabel: string;
  trailingSlot?: ReactNode;
  canEdit: boolean;
  isUploading: boolean;
  onPickFiles: (file: File | null | undefined) => void;
};

export default function TrainingTemplateResourceRow(props: Props) {
  const {
    actionsWidth,
    rowLabel,
    resourceUrl,
    openAriaLabel,
    uploadAriaLabel,
    trailingSlot,
    canEdit,
    isUploading,
    onPickFiles,
  } = props;

  return (
    <Grid xs={12}>
      <Grid container alignItems="center">
        <Grid xs sx={{ pr: 2 }}>
          <DarkInput value={rowLabel} readOnly fullWidth size="md" />
        </Grid>
        <Grid sx={{ width: actionsWidth, flex: "0 0 auto" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 1 }}>
            {resourceUrl ? (
              <IconButtonCTA
                ctaVariant="accent"
                aria-label={openAriaLabel}
                onClick={() => window.open(resourceUrl, "_blank")}
              >
                <OpenInNewIcon />
              </IconButtonCTA>
            ) : (
              <Box sx={{ width: 36, height: 36 }} />
            )}
            <IconButtonCTA
              ctaVariant="accent"
              aria-label={uploadAriaLabel}
              component="label"
              disabled={!canEdit || isUploading}
            >
              <CloudUploadIcon />
              <input
                hidden
                type="file"
                accept="application/pdf"
                onChange={(event) => onPickFiles(event.target.files?.[0])}
              />
            </IconButtonCTA>
            {trailingSlot ?? <Box sx={{ width: 36, height: 36 }} />}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
}
